
import { Options, Vue } from 'vue-class-component';
import { BagEstimationClient } from '@/services/Services';
import AdditionalProperties from './components/additionalProperties.vue';
import * as OM from '@/Model';

@Options({
    components: {
        AdditionalProperties
    }
})
export default class Accessories extends Vue {

    estimationIdentifier: string = "";
    accessoriesFromConfiguration: OM.BagAdditionalPropertiesConfiguration[] = [];
    estimationAccessories: OM.BagAdditionalProperty[] = [];

    loaded: boolean = false;
    
    created() {
        this.estimationIdentifier = this.$route.params.estimationIdentifier.toString();
        this.init();
    }

    init() {
        Promise.all([
            BagEstimationClient.getAccessoriesFromConfiguration(),
            BagEstimationClient.getAccessoriesAdditionalsFromEstimation(this.estimationIdentifier)
        ])
        .then( xs => {
            this.accessoriesFromConfiguration = xs[0];
            this.estimationAccessories = xs[1];

            setTimeout(() => {
                this.loaded = true;
            }, 300);
        })
    }

    updateAdditionalProperties(model: OM.BagEstimationAdditionalPropertyVM) {
        BagEstimationClient.updateAdditionalProperties(model)
        .then(x => {
            this.$router.push('/bag-calculator/processes-locations-and-transports/' + this.estimationIdentifier);
        })
    }
}
